// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../develop/node_modules/css-loader/index.js?minimize!../../../../../../develop/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eacd8cfc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderList.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../develop/node_modules/vue-style-loader/lib/addStylesClient.js")("f09f2e10", content, true, {});


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-style-loader!/Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eacd8cfc","scoped":false,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/OrderList.vue
// module id = 434
// module chunks = 0